module.exports = __webpack_public_path__ + "static/Iwan-edit-85fc6dbf2aeff060f9cdf3ad650faaf6.png";